/**
 * @generated SignedSource<<74bd2c4f1dc5f0bbf77e81d505b4c61a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectCell$data = {
  readonly id: string;
  readonly project: {
    readonly avatar: {
      readonly large: string | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "ProjectCell";
};
export type ProjectCell$key = {
  readonly " $data"?: ProjectCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ProjectCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProjectField"
};

(node as any).hash = "0010a81c0e94e4208da7772b6cf27cdc";

export default node;
